import React, {useMemo, useRef, useState} from 'react';
import dayjs from "dayjs";
import {PROCESSING_STAT} from "../../shared/utils/enum";
import TablePage from "../../pages/tablePage/TablePage";
import {Tag} from "antd";
import CampaignEditModal from "./CampaignEditModal";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import {useMailTitle} from "../country/useMailTitle";

const Campaign = () => {
    const [rowData, setRowData] = useState({});

    const refreshRef = useRef(null);
    const { data: mailTitle, isLoading, error } = useMailTitle();

    const columns = useMemo(() => ([
        {
            title: '우편No.',
            dataIndex: 'id',
            width: 100,
            sorter: true,
        },
        {
            title: '지급 대상',
            dataIndex: 'recipientType',
            render: (_, {recipientType}) => (
                <Tag color={recipientType ? 'blue' : 'green'}>
                    {recipientType ? '개별' : '전체'}
                </Tag>
            ),
            width: 100,
            filters: [
                {text: '개별', value: 1},
                {text: '전체', value: 0},
            ],
        },
        {
            title: '대상 버전',
            dataIndex: 'versionType',
            render: (_, {versionType, versions}) => (
                versionType
                    ? versions.split(',').filter(Boolean).map(v => <Tag key={v} color="purple">{v}</Tag>)
                    : <Tag color="green">전체</Tag>
            ),
            width: 150,
            filters: [
                {text: '지정 버전', value: 1},
                {text: '전체', value: 0},
            ],
        },
        {
            title: '우편 제목',
            dataIndex: 'title',
            width: 400,
            render: (_, {title}) => mailTitle.find(e => e.index === (isNaN(title) ? title : Number(title)))?.title.find(e => e.langCode === 'ko')?.text || title,
        },
        {
            title: '시작 시간',
            dataIndex: 'begin',
            render: (time) => dayjs.unix(time).format('YYYY-MM-DD HH:mm'),
            width: 150,
        },
        {
            title: '종료 시간',
            dataIndex: 'end',
            render: (time) => dayjs.unix(time).format('YYYY-MM-DD HH:mm'),
            width: 150,
        },
        {
            title: '유효 기간',
            dataIndex: 'validPeriod',
        },
        {
            title: '지급 상태',
            dataIndex: '',
            render: (_, {recipientType, begin, end}) => {
                let state = PROCESSING_STAT.PENDING;

                if (begin <= dayjs().unix() && dayjs().unix() <= end) {
                    state = PROCESSING_STAT.IN_PROGRESS;
                } else if (end < dayjs().unix()) {
                    state = PROCESSING_STAT.COMPLETE;
                }

                return (
                    <Tag
                        color={state > PROCESSING_STAT.IN_PROGRESS ? 'lightgray' : state < PROCESSING_STAT.IN_PROGRESS ? 'cyan' : 'geekblue'}>
                        {state > PROCESSING_STAT.IN_PROGRESS ? '발송 완료' : state < PROCESSING_STAT.IN_PROGRESS ? '발송 대기' : '발송 중'}
                    </Tag>
                )
            },
            width: 100,
        },
        {
            title: '사유',
            dataIndex: 'memo',
            search: true,
        },
    ]), [mailTitle]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        modal: CampaignEditModal,
        url: 'campaign',
        buttonText: '신규 우편 추가',
    }

    return (
        <TablePage {...props} />
    );
};

export default Campaign;